import { useCallback, useState } from "react";

// Préférence d'affichage mémorisée dans localStorage (repli silencieux en
// mémoire si le stockage est indisponible : navigation privée, quota…).
export function readPersisted(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}

export function writePersisted(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // stockage indisponible : la valeur reste en mémoire pour la session
  }
}

export default function usePersistedState(key, fallback) {
  const [value, setValue] = useState(() => readPersisted(key, fallback));
  const set = useCallback(
    (next) => {
      setValue((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        writePersisted(key, resolved);
        return resolved;
      });
    },
    [key]
  );
  return [value, set];
}
